module.exports = __webpack_public_path__ + "static/media/green-arrow-down.134bd15b.svg";